import { patchSetNieData } from '@nemuru-eng/js-api-client';

import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { mapNieDataToApiRequest } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/maps/mapNieDataToApiRequest';
import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { isNieDocumentType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';

interface PatchNieDataIfRequiredParams {
  onboardingDetails: StoredBorrowerOnboardingDetails;
  onboardingDetailsId: string;
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

const shouldPatchNieData = (
  onboardingDetails: StoredBorrowerOnboardingDetails,
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity,
): boolean => {
  if (!paymentMethodDetailEntity.requiresNieData()) {
    return false;
  }

  return isNieDocumentType(onboardingDetails.userDetails.documentId.type);
};

export const patchNieDataIfRequired = async ({
  onboardingDetails,
  onboardingDetailsId,
  paymentMethodDetailEntity,
}: PatchNieDataIfRequiredParams): Promise<boolean> => {
  if (!shouldPatchNieData(onboardingDetails, paymentMethodDetailEntity)) {
    return false;
  }

  const { nieData } = onboardingDetails;

  if (!nieData) {
    throw new Error('NIE data is required to patch NIE details');
  }

  await patchSetNieData({
    id: onboardingDetailsId,
    nieData: mapNieDataToApiRequest(onboardingDetails.userDetails.documentId.type, nieData),
  });

  return true;
};
